import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    SelectInput,
    required,
    ReferenceInput,
    DateTimeInput,
    ValidationError,
    useNotify,
    minValue,
    NumberInput,
} from 'react-admin';

import { Batches } from '../../custom';
import { EditToolbar } from '../../common/EditToolbar';
import { STATUSES } from '../../common/constants';
import FileUpload from '../../common/inputs/FileUpload';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import { BatchesTemplateAutoComplete } from '../../common/inputs/autoCompleteInputs/BatchTemplateAutoComplete';
import { validateEndDateAfterStart } from '../../common/string-utilities';

const BatchesEdit = () => {
    return (
        <Edit title={<BatchTitle />} mutationMode={'pessimistic'}>
            <SimpleForm toolbar={<EditToolbar />}>
                <FileUpload type="VIDEO_THUMBNAIL" source="image" accept={'image/*'} />
                <NumberInput
                    source="displayOrder"
                    type={'number'}
                    validate={[required(), minValue(0)]}
                    fullWidth
                />
                <TextInput source="title" validate={[required()]} fullWidth />
                <BatchesTemplateAutoComplete source="templateId" />
                <DateTimeInput source="startTime" validate={[required()]} fullWidth />
                <DateTimeInput
                    source="endTime"
                    validate={[
                        required(),
                        validateEndDateAfterStart(
                            'startTime',
                            'End time cannot be earlier than start time',
                        ),
                    ]}
                    fullWidth
                />
                <DateTimeInput source="registrationStartDate" validate={[required()]} fullWidth />
                <DateTimeInput
                    source="registrationEndDate"
                    validate={[
                        required(),
                        validateEndDateAfterStart(
                            'registrationStartDate',
                            'Registration end date cannot be earlier than registration start date',
                        ),
                    ]}
                    fullWidth
                />
                <SelectInput
                    source="status"
                    label={'Status'}
                    fullWidth
                    validate={[required()]}
                    choices={STATUSES}
                />
                <TextInput
                    rows={4}
                    multiline
                    source={'textDescription'}
                    fullWidth
                    validate={[required()]}
                />
                <HTMLEditorInput
                    source={'htmlDescription'}
                    fullWidth
                    validate={[required(), validHtml]}
                />
            </SimpleForm>
        </Edit>
    );
};

const BatchTitle = () => {
    const record = useRecordContext<Batches>();
    return record ? <span>{record.title}</span> : null;
};

export default BatchesEdit;
